import React, { useRef } from "react";
import { motion } from "framer-motion";

interface Props {
  value: bigint;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
  type: "ship" | "sheep";
}

export const FibButton = React.memo(function FibButton({
  value, selected, disabled, onClick, type
}: Props) {
  const len = value.toString().length;
  let fontSize = 18;
  if (len >= 4) fontSize = 14;
  if (len >= 6) fontSize = 11;
  if (len >= 8) fontSize = 9;

  const ref = useRef<HTMLButtonElement>(null);

  const onMove = (e: React.MouseEvent) => {
    if (disabled) return;
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.setProperty("--rx", `${(-y * 14).toFixed(2)}deg`);
    el.style.setProperty("--ry", `${(x * 14).toFixed(2)}deg`);
    el.style.setProperty("--mx", `${((x + 0.5) * 100).toFixed(1)}%`);
    el.style.setProperty("--my", `${((y + 0.5) * 100).toFixed(1)}%`);
  };
  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty("--rx", "0deg");
    el.style.setProperty("--ry", "0deg");
  };

  return (
    <motion.button
      ref={ref}
      whileTap={{ scale: 0.92 }}
      animate={selected ? { scale: 1.06 } : { scale: 1 }}
      transition={{ type: "spring", stiffness: 320, damping: 18 }}
      className={
        "fib-btn tilt" +
        (selected ? " selected" : "") +
        (type === "sheep" ? " sheep" : "")
      }
      disabled={disabled}
      onClick={onClick}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      type="button"
    >
      <span className="fib-shine" aria-hidden />
      <span className="fib-emoji">{type === "ship" ? "🚀" : "🐑"}</span>
      <span className="fib-value" style={{ fontSize }}>
        {value.toString()}
      </span>
    </motion.button>
  );
});
